import React from "react";

import useSWRWrapper, { ChildrenFunction, Fetcher } from "../../hooks/useSWRWrapper";
import { Product as ProductInterface } from "../../interfaces";

interface Props {
  id: number;
}

export const useProduct = (props: Props) => {
  const { id } = props;

  return useSWRWrapper<ProductInterface, Error>(
    `/api/products/${id}`,
    Fetcher({
      method: "GET",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    })
  );
};

const Product: React.FC<Props> = (props) => {
  const { children, ...rest } = props;
  const response = useProduct(rest);

  return (children as ChildrenFunction<ProductInterface, Error>)(response);
};

export default Product;
